import { Bold as OriginalBold } from "@tiptap/extension-bold";

import { remapShortcuts } from "./utils/remapShortcuts";

export const Bold = OriginalBold.extend(
  remapShortcuts({
    "Mod+KeyB": ({ editor }) => editor.commands.toggleBold(),
  }),
);
